// Pinned to the bottom of the menu column while the working copy has unpublished changes (PUB-01, PUB-02), and after a
// publish while the website rebuilds: "Sito in aggiornamento…", then "Sito aggiornato", or the failure with Riprova.
// The bar's text is a status region, so a screen reader hears the build move on.
import { Button } from "@/components/ui/Button";
import { cn } from "@/utils/cn";
import { TONE_CLASS, type PublishBarState } from "../format";

interface Props {
  state: PublishBarState | null;
  publishing: boolean;
  onPublish: () => void;
}

/** The bar's height plus its gap, for anything that floats above it (UndoToast). */
export const PUBLISH_BAR_CLEARANCE = 80;

export function PublishBar({ state, publishing, onPublish }: Props) {
  if (!state) return null;
  return (
    <div className="sticky bottom-0 z-20 pb-[max(12px,env(safe-area-inset-bottom))] pt-3">
      <div className="flex items-center gap-3 rounded-2xl bg-white px-4 py-[10px] shadow-[0_4px_24px_rgba(15,23,42,0.10)] ring-1 ring-gray-900/5">
        <div role="status" aria-label="Pubblicazione" className="min-w-0 flex-1 text-[13px] leading-[18px]">
          {state.message && <p className="font-medium text-gray-900">{state.message}</p>}
          {state.site && <p className={cn(state.message ? "text-[12px]" : "font-medium", TONE_CLASS[state.site.tone])}>{state.site.text}</p>}
        </div>
        {state.action && (
          <Button onClick={onPublish} isLoading={publishing} className="h-[38px] shrink-0 px-5 text-[13px]">
            {state.action}
          </Button>
        )}
      </div>
    </div>
  );
}
